// Mirrors the backend so a mistake is caught before a real invite email is sent or a
// submission is rejected: `is_valid_company_name` and `FRN_PATTERN` in the core-api.
const MAX_COMPANY_NAME_LENGTH = 50;
const ALPHANUMERIC_REGEX = /[A-Za-z0-9]/;

export const validateCompanyName = (value: string): string | null => {
  const trimmed = value.trim();
  if (trimmed.length === 0) return 'Company name is required';
  if (trimmed.length > MAX_COMPANY_NAME_LENGTH) {
    return `Company name must be ${MAX_COMPANY_NAME_LENGTH} characters or fewer`;
  }
  if (!ALPHANUMERIC_REGEX.test(trimmed)) {
    return 'Company name must contain at least one letter or number';
  }
  return null;
};
